'use strict';

var ServicesFilterByDateRangeFactory = function ServicesFilterByDateRangeFactory(DataRangeFilter, momentService) {
  function ServicesFilterByDateRange() {
    DataRangeFilter.call(this, 'contributing-services-mode', 'fbcs-grid', 2);
  }
  ServicesFilterByDateRange.prototype = Object.create(DataRangeFilter.prototype);
  ServicesFilterByDateRange.prototype.filter = function (data, range) {
    range = range[0];
    var dateRanges = range.dateRanges;
    var self = this;
    var cachedResult = {};
    var results = [];
    if (Array.isArray(dateRanges) && dateRanges.length >= 1) {
      var filterFunction = self.filterGroup(dateRanges);
      for (var j = 0, length = data.length; j < length; j++) {
        var element = data[j];
        var applicableDateRangeStart = element.applicableDateRangeBegin;
        var applicableDateRangeEnd = element.applicableDateRangeEnd;
        var cacheKey = applicableDateRangeStart.valueOf() + '-' + applicableDateRangeEnd.valueOf();
        var filterResult = cachedResult[cacheKey];
        if (filterResult === undefined) {
          var filterResultDateRangeStart = filterFunction(applicableDateRangeStart);
          var filterResultDateRangeEnd = filterFunction(applicableDateRangeEnd);
          filterResult = filterResultDateRangeStart || filterResultDateRangeEnd;
          cachedResult[cacheKey] = filterResult;
        }
        if (filterResult === true) {
          results.push(element);
        }
      }
      return results;
    } else {
      return data;
    }
  };
  ServicesFilterByDateRange.prototype.filterGroup = function (dateRange) {
    return function (departureDate) {
      for (var i = 0, len = dateRange.length; i < len; i++) {
        var val = dateRange[i];
        if (!departureDate.isBefore(momentService.of(val.split(',')[0], momentService.FIELD.APPLICABLE_DATE_RANGE)) && !departureDate.isAfter(momentService.of(val.split(',')[1], momentService.FIELD.APPLICABLE_DATE_RANGE))) {
          return true;
        }
      }
    };
  };
  return ServicesFilterByDateRange;
};
ServicesFilterByDateRangeFactory.$inject = ['DataRangeFilterFactory', 'MomentService'];
module.exports = ServicesFilterByDateRangeFactory;